import React, { useState, useEffect } from 'react';
import { fetchFuelRecords, addFuelRecord } from '../services/api';
import FuelGauge from './FuelGauge';

interface FuelTrackerProps {
  carId: number;
  onUpdate?: () => void;
}

const FuelTracker: React.FC<FuelTrackerProps> = ({ carId, onUpdate }) => {
  const [data, setData] = useState<any>({ records: [], stats: [] });
  const [form, setForm] = useState({
    mileage: '',
    liters: '',
    cost: '',
    date: new Date().toISOString().split('T')[0],
    full_tank: true
  });
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      const result = await fetchFuelRecords(carId);
      setData(result);
    } catch (error) {
      console.error("Error loading fuel data", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [carId]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await addFuelRecord({
        car_id: carId,
        ...form,
        mileage: parseInt(form.mileage),
        liters: parseFloat(form.liters),
        cost: form.cost ? parseFloat(form.cost) : 0
      });
      setForm({ ...form, mileage: '', liters: '', cost: '' });
      loadData();
      if (onUpdate) onUpdate();
    } catch (error) {
      alert("Error al registrar combustible");
    }
  };

  if (loading) return <div>Cargando combustible...</div>;

  return (
    <div className="fuel-tracker">
      <div className="gauge-section" style={{ padding: '1rem 0', marginBottom: '1rem' }}>
        {data.stats && data.stats.length > 0 ? (
          <FuelGauge value={data.stats[0].km_per_liter} label="KM/L Promedio" />
        ) : (
          <div style={{ textAlign: 'center', color: 'var(--text-secondary)', fontSize: '0.8rem', padding: '1rem' }}>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>⛽</div>
            Carga 2 tanques llenos para ver estadísticas.
          </div>
        )}
      </div>

      <form onSubmit={handleSubmit} style={{ background: 'rgba(0,0,0,0.2)', padding: '1rem', borderRadius: '12px', marginBottom: '1.5rem', border: '1px solid rgba(255,255,255,0.05)' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginBottom: '0.75rem' }}>
          <div className="input-mini">
            <label style={{ fontSize: '0.7rem', marginBottom: '0.2rem' }}>KM actual</label>
            <input 
              type="number" className="form-control"
              value={form.mileage} onChange={e => setForm({...form, mileage: e.target.value})} required
            />
          </div>
          <div className="input-mini">
            <label style={{ fontSize: '0.7rem', marginBottom: '0.2rem' }}>Litros</label>
            <input 
              type="number" step="0.01" className="form-control"
              value={form.liters} onChange={e => setForm({...form, liters: e.target.value})} required
            />
          </div>
          <div className="input-mini">
            <label style={{ fontSize: '0.7rem', marginBottom: '0.2rem' }}>Costo ($)</label>
            <input 
              type="number" step="0.01" className="form-control"
              value={form.cost} onChange={e => setForm({...form, cost: e.target.value})}
            />
          </div>
          <div className="input-mini">
            <label style={{ fontSize: '0.7rem', marginBottom: '0.2rem' }}>Fecha</label>
            <input 
              type="date" className="form-control"
              value={form.date} onChange={e => setForm({...form, date: e.target.value})} required
            />
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <label style={{ fontSize: '0.8rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input 
              type="checkbox" checked={form.full_tank} 
              onChange={e => setForm({...form, full_tank: e.target.checked})}
              style={{ width: 'auto' }}
            /> Tanque Lleno
          </label>
          <button type="submit" className="btn btn-primary" style={{ padding: '0.4rem 1rem' }}>Cargar</button>
        </div>
      </form>

      <div className="history-list" style={{ maxHeight: '180px', overflowY: 'auto' }}>
        <table className="table" style={{ width: '100%', fontSize: '0.8rem' }}>
          <thead>
            <tr>
              <th>Fecha</th>
              <th>KM</th>
              <th>Litros</th>
              <th>km/L</th>
            </tr>
          </thead>
          <tbody>
            {data.stats.map((stat: any, idx: number) => (
              <tr key={idx}>
                <td>{new Date(stat.date).toLocaleDateString()}</td>
                <td>{stat.km_traveled}</td>
                <td>{stat.liters}L</td>
                <td style={{ fontWeight: 'bold', color: stat.km_per_liter >= 12 ? '#4ade80' : '#fbbf24' }}>
                  {stat.km_per_liter}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FuelTracker;
